<wbo-report-page #reportPage [formGroup]="reportPage.formGroup">
    <fui-formation-group-template
        *formationGroup="{title: 'wbo.product-plu-report.edit.formation.productSelection', formControlNames: ''}">
        <fui-rows>
            <fui-row>
                <wbo-sellable-report-selection></wbo-sellable-report-selection>
            </fui-row>
        </fui-rows>
    </fui-formation-group-template>
</wbo-report-page>
